

import React from 'react'
import classNames from 'classnames'
import { string, oneOfType, object, bool, func } from 'prop-types'

class Modal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      visible: this.props.visible || false
    }
    this.hideModal = this.hideModal.bind(this)
  }

  componentDidUpdate () {
    if (
      (this.props.visible === false && this.state.visible === true) ||
      (this.props.visible === true && this.state.visible === false)
    ) this.toggleVisible(this.props.visible)
  }

  hideModal () {
    if (this.props.closeCallBack) this.props.closeCallBack()
  }

  toggleVisible (visible) {
    this.setState({
      visible
    })
  }

  render () {
    const { id, heading, lead, content } = this.props
    const { visible } = this.state
    const style = {display: (visible ? 'block' : 'none')}
    const modalClass = classNames({
      'modal': true,
      'fade': true,
      'in': visible
    })
    return (
      <div role='dialog' aria-labelledby={id + 'Heading'} className={modalClass} id={id} style={style}>
        <div className='modal-dialog'>
          <div className='modal-content'>
            { (heading || lead) && <div className='modal-header'>
              <button ref={(c) => (this._modalCloseButton = c)} className='close' data-hxtrack-name='close_modal' data-dismiss='modal' type='button' aria-label='Close' onClick={this.hideModal}><span aria-hidden='true'>×</span></button>
                { heading && (<h4 className='modal-title' id={id + 'Heading'}>{heading}</h4>) }
                { lead && (<p className='lead'>{lead}</p>) }
              </div> }
            { content && typeof content === 'object' && (
            <div className='modal-body'>{ content }</div>
              )}
            { content && typeof content !== 'object' && (
            <div className='modal-body' dangerouslySetInnerHTML={{ __html: content }} />
              )}
          </div>
        </div>
      </div>
    )
  }
}

Modal.propTypes = {
  id: string.isRequired,
  heading: string,
  lead: string,
  content: oneOfType([ string, object ]),
  visible: bool,
  closeCallBack: func
}
Modal.defaultProps = {
  visible: false
}

export default Modal



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/modal.jsx